export default "__VITE_ASSET__BgaDKBuL__"